/**
 * Assets del producto DPS43 · Troop Night Ready.
 *
 * MAIN_MOCKUP_URL: mockup principal, usado en el hero y en el recuadro de precio.
 */
export const MAIN_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/opVCCRYqMo9NQc36kzPp73/Photorealistic-product-mockup-warm-cine.png'

/** Páginas reales del Volumen 2 (Gamma), formato 9:16. */
export const PAGE_IMAGES = {
  cover:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/0Etcih1wl4aWTWM_.jpg',
  formula:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/FPH_kHq4MV392wkX.jpg',
  meetingCard:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/1ygesU2n01ISJdR4.jpg',
  skillStation:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/D6WCTdc29Yg2zdzA.jpg',
  patrolChallenge:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/SlGgdBiPlYjjJ1Hh.jpg',
  wrongRight:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/7HWig-JKzCjH8SHE.jpg',
  worksheet:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/-Rq0fxV_9344Brfz.jpg',
}
